import { render, staticRenderFns } from "./ActDis.vue?vue&type=template&id=9f5054d0&"
import script from "./ActDis.vue?vue&type=script&lang=js&"
export * from "./ActDis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports